import { render, staticRenderFns } from "./HowToNBIoT.vue?vue&type=template&id=7b06ac85&scoped=true&"
import script from "./HowToNBIoT.vue?vue&type=script&lang=js&"
export * from "./HowToNBIoT.vue?vue&type=script&lang=js&"
import style0 from "./HowToNBIoT.vue?vue&type=style&index=0&id=7b06ac85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06ac85",
  null
  
)

export default component.exports